module.exports = {"450422100":"藤州镇","450422103":"塘步镇","450422104":"埌南镇","450422105":"同心镇","450422106":"金鸡镇","450422107":"新庆镇","450422108":"象棋镇","450422109":"岭景镇","450422110":"天平镇","450422111":"蒙江镇","450422112":"和平镇","450422113":"太平镇","450422114":"古龙镇","450422115":"东荣镇","450422116":"大黎镇","450422200":"平福乡","450422201":"宁康乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450422.json
// module id = 2114
// module chunks = 0